module.exports = __webpack_public_path__ + "assets/address-156f42.svg";